import React from "react";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";

/**
 * PublicPageLayout - Wrapper component for public pages
 * Provides consistent header, main content area, and footer
 * Similar structure to MainLayout but for anonymous users
 */
const PublicPageLayout = ({ children }) => {
    return (
        <div className="d-flex flex-column min-vh-100">
            <header>
                <div className="container-fluid p-0">
                    <PublicHeader />
                </div>
            </header>
            <main className="flex-grow-1" style={{ overflowY: 'auto' }}>
                <div className="py-3">
                    {children}
                </div>
            </main>
            <footer className="mt-auto">
                <div className="container-fluid p-0">
                    <PublicFooter />
                </div>
            </footer>
        </div>
    );
};

export default PublicPageLayout;
